import { useCallback } from 'react';
import { useSceneState, useSceneActions } from '../../presentation/providers/SceneProvider';

export function useCuboidHover() {
  const { hoveredCuboid, pinnedCuboid, currentFrame } = useSceneState();
  const { setHoveredCuboid, setPinnedCuboid } = useSceneActions();

  const onHover = useCallback((uuid: string) => {
    const cuboid = currentFrame?.getCuboid(uuid) ?? null;
    setHoveredCuboid(cuboid);
  }, [currentFrame, setHoveredCuboid]);

  const onUnhover = useCallback(() => {
    setHoveredCuboid(null);
  }, [setHoveredCuboid]);

  const onPin = useCallback((uuid: string) => {
    if (pinnedCuboid?.uuid === uuid) {
      setPinnedCuboid(null);
    } else {
      const cuboid = currentFrame?.getCuboid(uuid) ?? null;
      setPinnedCuboid(cuboid);
    }
  }, [currentFrame, pinnedCuboid, setPinnedCuboid]);

  const onUnpin = useCallback(() => {
    setPinnedCuboid(null);
  }, [setPinnedCuboid]);

  const activeCuboid = pinnedCuboid ?? hoveredCuboid;

  return { hoveredCuboid, pinnedCuboid, activeCuboid, onHover, onUnhover, onPin, onUnpin };
}
